import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--cco-line);
  border-radius: 10px;
  background: var(--cco-soft-surface);
  margin-bottom: 12px;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
`;

export const HeadLabel = styled.span`
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--cco-ink-mute);
`;

export const PeriodToggle = styled.div`
  display: inline-flex;
  padding: 2px;
  gap: 2px;
  border-radius: 7px;
  background: var(--cco-bg);
  border: 1px solid var(--cco-line);
`;

export const PeriodBtn = styled.button`
  padding: 4px 10px;
  border: none;
  border-radius: 5px;
  background: ${(props) => (props.$active ? 'var(--cco-red)' : 'transparent')};
  color: ${(props) => (props.$active ? '#fff' : 'var(--cco-ink-mute)')};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  transition: background 150ms, color 150ms;
`;

export const Kpis = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Kpi = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 70px;
`;

export const KpiLabel = styled.span`
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--cco-ink-faint);
`;

export const KpiValue = styled.span`
  font-size: 17px;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  color: ${(props) => (props.$alarm ? 'var(--cco-red)' : 'var(--cco-ink)')};
  white-space: nowrap;
`;

export const Pareto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid var(--cco-line);
  padding-top: 10px;
`;

export const ParetoTitle = styled.span`
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--cco-ink-faint);
`;

export const ParetoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ParetoHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const ParetoCause = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ParetoMeta = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const ParetoTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: var(--cco-bg);
  border: 1px solid var(--cco-line);
  overflow: hidden;
`;

export const ParetoFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: var(--cco-red);
  min-width: 2px;
  transition: width 400ms ease;
`;

export const Empty = styled.div`
  font-size: 12px;
  color: var(--cco-ink-faint);
`;
